import React from "react";
import LinearProgress from "@material-ui/core/LinearProgress";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {InputText} from "primereact/inputtext";
import {Dialog} from "primereact/dialog";
import Divider from "@material-ui/core/Divider";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const ValueTypeView = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '0%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.deleteGroupConfMsg}
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Mantenimiento \ Tipos de Valor"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button label="Buscar" style={{'float': 'right'}}
                                onClick={props.getValueTypes}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider/>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <Button type="button" iconPos="left" label="Contraer/Expandir"
                                    style={{marginRight: '.5em'}}
                                    className="p-button-secondary"
                                    onClick={props.expandReduceAll}/>
                            <Button type="button" iconPos="left" label="Agregar"
                                    className="p-button-secondary"
                                    onClick={props.addGroup}/>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.valueTypeList}
                            selectionMode="single"
                            expandedRows={props.expandedRows}
                            onRowToggle={props.handleToggle}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            selection={props.selectedGroup}
                            onSelectionChange={props.selectRowControlPanel}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column expander={true} style={{width: '3em'}}/>
                            <Column field="groupName" header="Grupo" style={{textAlign: 'left'}} sortable={true}/>
                            <Column header="Acciones"
                                    body={props.groupTemplate}
                                    style={{textAlign: 'center', width: '8em'}}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                    onHide={props.onHideDialog} closable={false}>
                {
                    <div className="p-grid p-fluid">
                        <div className="p-col-12" style={{padding: '.5em'}}>
                            <SubtitleLabel header="Grupo" isBold={true}/>
                            <SubtitleLabel header={props.valueTypeSelected.groupName} />
                        </div>
                        <div className="p-col-6" style={{padding: '.5em'}}>
                            <SubtitleLabel header="Nombre del Valor" isBold={true}/>
                            <SubtitleLabel header={props.valueTypeSelected.nombre} />
                        </div>
                        <div className="p-col-6" style={{padding: '.5em'}}>
                            <SubtitleLabel header="Descripción" isBold={true}/>
                            <SubtitleLabel header={props.valueTypeSelected.descripcion} />
                        </div>
                        <div className="p-col-12" style={{padding: '.5em'}}>
                            <SubtitleLabel header="Etiqueta" isBold={true}/>
                            <InputText name="etiqueta"
                                       onChange={props.onChangeTextDialog}
                                       value={props.valueTypeSelected.etiqueta}
                                       placeholder="Ex. usuario@servidor.com"/>
                        </div>
                    </div>
                }
            </Dialog>
        </React.Fragment>
    )
};

export default ValueTypeView;